import * as types from '../mutation-types';

// state
export const state = {
  propertyTenure: null,
};

// mutations
export const mutations = {
  [types.SET_PROPERTY_TENURE](state, propertyTenure) {
    state.propertyTenure = propertyTenure;
  },
};

// actions
export const actions = {
  setPropertyTenure({ commit, state, dispatch }, id) {
    commit(types.SET_PROPERTY_TENURE, id);
  },
};

// getters
export const getters = {
  propertyTenure: state => state.propertyTenure,
};
